import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const Profile = () => {
  const [username, setUsername] = useState("");
  const [location, setLocation] = useState("Carregando...");
  const [ip, setIp] = useState("Carregando...");
  const [loginTime, setLoginTime] = useState("");
  const [browserInfo, setBrowserInfo] = useState("");
  const [timezone, setTimezone] = useState("");
  const [language, setLanguage] = useState("");

  useEffect(() => {
    // 🔐 Token do usuário
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setUsername(decodedToken.username);
      } catch (error) {
        console.error("Token inválido", error);
      }
    }

    // 🌐 Info do navegador
    setLoginTime(new Date().toLocaleString());
    setBrowserInfo(navigator.userAgent);
    setTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
    setLanguage(navigator.language || navigator.userLanguage);

    // 🌍 Localização via backend (evita bloqueios HTTPS)
    axios
      .get(`${API_URL}/location`)
      .then((response) => {
        setLocation(`${response.data.city}, ${response.data.country}`);
        setIp(response.data.query);
      })
      .catch((error) => {
        console.error("Erro ao obter localização", error);
        setLocation("Indisponível");
        setIp("Indisponível");
      });
  }, []);

  const handleRestartBackend = async () => {
    if (window.confirm("Tem certeza que deseja reiniciar o servidor backend?")) {
      try {
        const response = await axios.post(`${API_URL}/system/restart-backend`);
        alert(response.data.message || "Reinício solicitado com sucesso.");
      } catch (error) {
        alert("Erro ao reiniciar servidor: " + (error.response?.data?.message || error.message));
      }
    }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">My Account</h3>
                  </Col>
                  <Col className="text-right" xs="4">
                    <Button color="danger" size="sm" onClick={handleRestartBackend}>
                      Reiniciar Servidor
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4">User Information</h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-username">
                            Username
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-username"
                            type="text"
                            value={username}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>

                  <hr className="my-4" />
                  <h6 className="heading-small text-muted mb-4">Additional Information</h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-control-label">Login Time</label>
                          <Input
                            className="form-control-alternative"
                            value={loginTime}
                            type="text"
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-control-label">Location</label>
                          <Input
                            className="form-control-alternative"
                            value={location}
                            type="text"
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-control-label">IP Address</label>
                          <Input
                            className="form-control-alternative"
                            value={ip}
                            type="text"
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-control-label">Browser</label>
                          <Input
                            className="form-control-alternative"
                            value={browserInfo}
                            type="text"
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-control-label">Time Zone</label>
                          <Input
                            className="form-control-alternative"
                            value={timezone}
                            type="text"
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup>
                          <label className="form-control-label">Language</label>
                          <Input
                            className="form-control-alternative"
                            value={language}
                            type="text"
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Profile;